import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { AuthErrorContext, getAuthErrorMessage } from '../utils/authErrors';

/**
 * Returns `showAuthError(error, fallback, context?)`, which shows a Firebase Auth or Cloud
 * Function error as an error snackbar. Errors that should stay silent (e.g. a closed Google
 * popup) show nothing.
 */
function useAuthErrorSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  return useCallback(
    (error: unknown, fallback: string, context?: AuthErrorContext) => {
      const message = getAuthErrorMessage(error, fallback, context);
      if (message) {
        enqueueSnackbar(message, { variant: 'error' });
      }
    },
    [enqueueSnackbar]
  );
}

export default useAuthErrorSnackbar;
